import axios from "axios";
import request from "@/utils/request";

export function sendCaptcha(data) {
  return request({
    url: "/api/sms/sendNew",
    method: "post",
    data,
  });
}

// 判断手机号是否存在且绑定微信
export function checkMobile(data) {
  return request({
    url: "/api/user/checkMobileInfo",
    method: "post",
    data,
  });
}

// 用户登录
export function userLogin(data) {
  return request({
    url: "/api/user/login",
    method: "post",
    data,
  });
}
// 验证码登录
export function userCodeLogin(data) {
  return request({
    url: "/api/user/mobilelogin",
    method: "post",
    data,
  });
}

// 退出登录
export function userLogout(data) {
  return request({
    url: "/api/user/logout",
    method: "get",
    data,
  });
}

// 获取用户信息
export function userInfo(data) {
  return request({
    url: "/api/user/index",
    method: "post",
    data,
  });
}

// 转链
export function transformUrl(data) {
  return request({
    url: "/api/goods/linkConvert",
    method: "post",
    data,
    rawResponse: true,
  });
}

// 协议
export function protocolDetail(data) {
  return request({
    url: "/api/index/ruleContent",
    method: "post",
    data,
  });
}

export function getThemeConfig(data) {
  return request({
    url: "/goapi/setting/webtool",
    method: "post",
    data,
  });
}
export function getOrderList(data) {
  return request({
    url: "/api/order/OrderList",
    method: "post",
    data,
  });
}
export function getFansOrder(data) {
  return request({
    url: "/api/order/FansOrder",
    method: "post",
    data,
  });
}
export function getOrderStat(data) {
  return request({
    url: "/api/order/orderStat",
    method: "post",
    data,
  });
}
export function nativeCenterCfg(data) {
  return request({
    url: "/api/index/nativeCenterCfg",
    method: "post",
    data,
  });
}
// 转链
export function GetJdUrl(data) {
  return request({
    url: "/api/goods/GetJdUrl",
    method: "post",
    data,
  });
}
export function getPddUrl(data) {
  return request({
    url: "/api/goods/GetPddUrl",
    method: "post",
    data,
  });
}
export function getTaobaoUrl(data) {
  return request({
    url: "/api/goods/GetTaobaoUrl",
    method: "post",
    data,
  });
}
export function vipGetUrl(data) {
  return request({
    url: "/api/goods/vipGetUrl",
    method: "post",
    data,
  });
}
export function getDouyinUrl(data) {
  return request({
    url: "/api/douyin/getUrl",
    method: "post",
    data,
  });
}
export function getKsUrl(data) {
  return request({
    url: "/api/kuaishou/getUrl",
    method: "post",
    data,
  });
}
export function storePromotionUrl(data) {
  return request({
    url: "/api/suning/storePromotionUrl",
    method: "post",
    data,
  });
}
export function getMediaLink(data) {
  return request({
    url: "/api/meituan_dist/getMediaLink",
    method: "post",
    data,
  });
}
export function getXianYuUrl(data) {
  return request({
    url: "/api/taobao/getUrlGoofish",
    method: "post",
    data,
  });
}
export function kaolaGoodsInfo(data) {
  return request({
    url: "/api/kaola/goodsInfo",
    method: "post",
    data,
  });
}
export function getUrlLive(data) {
  return request({
    url: "/api/taobao/getUrlLive",
    method: "post",
    data,
  });
}
export function fullSearchLive(data) {
  return request({
    url: "/api/taobao/fullSearchLive",
    method: "post",
    data,
  });
}

// 统一商品专辑详情
export function getHezuoThemeDetail(data) {
  return request({
    url: "/api/other/getDetailHezuoTheme",
    method: "post",
    data,
  });
}

// 快手详情
export function getGoodsInfo(data) {
  return request({
    url: "/api/kuaishou/getGoodsInfo",
    method: "post",
    data,
  });
}
export function suNingGoodsDetail(data) {
  return request({
    url: "/api/goods/suNingGoodsDetail",
    method: "post",
    data,
  });
}
export function pddGoodsInfoNew(data) {
  return request({
    url: "/api/goods/PddGoodsInfoNew",
    method: "post",
    data,
  });
}
export function jdGoodsInfoNew(data) {
  return request({
    url: "/api/goods/JdGoodsInfoNew",
    method: "post",
    data,
  });
}
export function vipGoodsInfo(data) {
  return request({
    url: "/api/goods/vipGoodsInfo",
    method: "post",
    data,
  });
}
export function douyinGoodsInfo(data) {
  return request({
    url: "/api/douyin/getGoodsInfo",
    method: "post",
    data,
  });
}
export function getTaobaoGoodsInfo(data) {
  return request({
    url: "/api/goods/getTaobaoGoodsInfo",
    method: "post",
    data,
  });
}
export function getXianGoodsInfo(data) {
  return request({
    url: "/api/taobao/getGoodsInfoGoofish",
    method: "post",
    data,
  });
}
export function checkBeian(data) {
  return request({
    url: "/api/user/checkBeian",
    method: "post",
    data,
  });
}
export function getGrankList(data) {
  return request({
    url: "/api/ranking/platformOrderStat",
    method: "post",
    data,
  });
}

// 团队成员整体数据展示
export function getTeamFansIndex(data) {
  return request({
    url: "/api/team_fans/index",
    method: "post",
    data,
  });
}

// 团队成员列表
export function getTeamFansList(data) {
  return request({
    url: "/api/team_fans/fansList",
    method: "post",
    data,
  });
}

// 成员收益概况
export function getFansIncome(data) {
  return request({
    url: "/api/agent/fansIncome",
    method: "post",
    data,
  });
}

// 添加直属会员
export function addUser(data) {
  return request({
    url: "/api/pc_web/addUser",
    method: "post",
    data,
  });
}

// 成员团队
export function getFansTeam(data) {
  return request({
    url: "/api/agent/fansTeam",
    method: "post",
    data,
  });
}

// 获取分享加密码
export function getAppShareXcode(data) {
  return request({
    url: "/api/kweb/getAppShareXcode",
    method: "post",
    data,
  });
}

// 获取分享信息
export function getAppShareInfo(data) {
  return request({
    url: "/api/kweb/getAppShareInfo",
    method: "post",
    data,
  });
}

// 获取快站通用分享链接
export function kwebGetShareUrl(data) {
  return request({
    url: "/api/kweb/getShareUrl",
    method: "post",
    data,
  });
}

// 团队数据趋势
export function getFansByTime(data) {
  return request({
    url: "/api/team_fans/getFansByTime",
    method: "post",
    data,
  });
}
// 提交申请导出任务
export function exportApply(data) {
  return request({
    url: "/goapi/export/apply",
    method: "post",
    data,
  });
}
// 最后导出记录
export function exportLast(data) {
  return request({
    url: "/goapi/export/last",
    method: "post",
    data,
  });
}
// 导出记录
export function exportList(data) {
  return request({
    url: "/goapi/export/list",
    method: "post",
    data,
  });
}
// 抖音分类
export function getDouyinListCate(data) {
  return request({
    url: "/api/douyin/getListCate",
    method: "post",
    data,
  });
}
// 抖音品牌列表
export function getDouyinBrandList(data) {
  return request({
    url: "/api/douyin/brandList",
    method: "post",
    data,
  });
}
// 抖音高佣商品列表
export function getDyHighCommissionList(data) {
  return request({
    url: "/api/douyin/getLbproductList",
    method: "post",
    data,
  });
}
// 抖音高佣商品转链
export function getUrlCpm(data) {
  return request({
    url: "/api/douyin/getUrlCpm",
    method: "post",
    data,
  });
}
export function getDouyinFullSearch(data) {
  return request({
    url: "/api/douyin/fullSearch",
    method: "post",
    data,
  });
}
// 抖音本地库搜索
export function getDouyinLocalSearch(data) {
  return request({
    url: "/api/douyin/fullSearch",
    method: "post",
    data,
  });
}
// 抖音CPM商品列表
export function getDouyinListCpmGoods(data) {
  return request({
    url: "/api/douyin/getListCpmGoods",
    method: "post",
    data,
  });
}

// 收藏或取消收藏商品
export function updateGoodsCollect(data) {
  return request({
    url: "/api/collect/collect",
    method: "post",
    data,
  });
}

// 收藏列表
export function getGoodsCollectList(data) {
  return request({
    url: "/api/collect/index",
    method: "post",
    data,
  });
}

// 批量取消商品收藏
export function multiCleanGoodsCollect(data) {
  return request({
    url: "/api/collect/multiClean",
    method: "post",
    data,
  });
}

// 中免日上分类
export function getCdfSunriseCateList(data) {
  return request({
    url: "/goapi/cdf_sunrise/cateList",
    method: "post",
    data,
  });
}

// 中免日上商品列表
export function getCdfSunriseGoodsList(data) {
  return request({
    url: "/api/cdf_sunrise/fullSearch",
    method: "post",
    data,
  });
}

// 全平台商品统一转链
export function getGoodsUrl(data) {
  return request({
    url: "/api/goods/getUrl",
    method: "post",
    data,
  });
}

/*****************************子账号************************** */

// 登录
export function subAccountLogin(data) {
  return request({
    url: '/api/user/accountLogin',
    method: 'post',
    data
  })
}

// 列表
export function subAccountList(data) {
  return request({
    url: '/api/user_account/list',
    method: 'post',
    data
  })
}

// 添加
export function subAccountAdd(data) {
  return request({
    url: '/api/user_account/add',
    method: 'post',
    data
  })
}

// 删除
export function subAccountDel(data) {
  return request({
    url: '/api/user_account/del',
    method: 'post',
    data
  })
}
// 编辑
export function subAccountEdit(data) {
  return request({
    url: '/api/user_account/edit',
    method: 'post',
    data
  })
}
